export enum InputTypeEnum {
    EMAIL = "email",
    PASSWORD = "password",
    TEL = "tel",
    TEXT = "text",
}

export enum InputVariantEnum {
    DEFAULT = "default",
    PRIMARY = "primary",
}
